import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{ path: '', redirectTo: 'home', pathMatch: 'prefix' },
			{ path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
			{ path: 'list/:entidade', loadChildren: () => import('./list/list.module').then(m => m.ListModule) },
			{ path: 'analisislist', loadChildren: () => import('./analisis-list/analisis-list.module').then(m => m.AnalisisListModule) },
			{ path: 'analysecredit/:id', loadChildren: () => import('./financing/financing.module').then(m => m.FinancingModule) },
			{ path: 'analysecredit', loadChildren: () => import('./financing/financing.module').then(m => m.FinancingModule) },
			{ path: 'configurations', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule) },
			{ path: 'user-permission', loadChildren: () => import('./user-permission/user-permission.module').then(m => m.UserPermissionModule) },
			{ path: 'logout', loadChildren: () => import('./logout/logout.module').then(m => m.LogoutModule) },
			{ path: 'alter-password', loadChildren: () => import('./user-alterpassword/user-alterpassword.module').then(m => m.UserAlterPasswordModule) }
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class LayoutRoutingModule { }
